import React from 'react';
import C2Picker from '../../colorPicker/ColorPicker.js';

const C2ColorPicker = (props) => {
    const { opts } = props;
    return React.createElement("span", { className: "field" },
        React.createElement("label", { htmlFor: "btngr" }, opts.label),
        React.createElement(C2Picker, null));
};

export { C2ColorPicker as default };
//# sourceMappingURL=C2ColorPicker.js.map
